import {
  LegalStatus,
  UserInfo,
  WorksheetData,
} from '../Registration.interfaces';

export const getInitialValues = (userInfo: UserInfo): WorksheetData => {
  if (userInfo.legalStatus === LegalStatus.LEGAL) {
    return {
      fullNameRu: userInfo?.fullNameRu,
      fullNameEn: userInfo?.fullNameEn,
      shortNameEn: userInfo?.shortNameEn,
      shortNameRu: userInfo?.shortNameRu,
      countryId: userInfo?.countryId,
      inn: userInfo?.inn,
      regNumber: userInfo?.regNumber,
      regDate: userInfo?.regDate,
      registrationAuthorityRu: userInfo?.registrationAuthorityRu,
      registrationAuthorityEn: userInfo?.registrationAuthorityEn,
      addressRu: userInfo?.addressRu,
      addressEn: userInfo?.addressEn,
      eMail: userInfo?.eMail,
      phone: userInfo?.phone,
      basisRuGC: userInfo?.basisRuGC,
      basisEn: userInfo?.basisEn,
      signatoryRu: userInfo?.signatoryRu,
      signatoryRuGC: userInfo?.signatoryRuGC,
      signatoryEn: userInfo?.signatoryEn,
      signatoryPositionRu: userInfo?.signatoryPositionRu,
      signatoryPositionRuGC: userInfo?.signatoryPositionRuGC,
      signatoryPositionEn: userInfo?.signatoryPositionEn,
      eMailOrganization: userInfo?.eMailOrganization,
    };
  } else if (userInfo.legalStatus === LegalStatus.INDIVIDUAL) {
    return {
      indFamily: userInfo?.indFamily,
      indName: userInfo?.indName,
      indSurname: userInfo?.indSurname,
      indFamilyEn: userInfo?.indFamilyEn,
      indNameEn: userInfo?.indNameEn,
      indSurnameEn: userInfo?.indSurnameEn,
      identityDocument: userInfo?.identityDocument,
      identityDocumentEn: userInfo?.identityDocumentEn,
      countryId: userInfo?.countryId,
      inn: userInfo?.inn,
      addressRu: userInfo?.addressRu,
      addressEn: userInfo?.addressEn,
      actualAddressRu: userInfo?.actualAddressRu,
      actualAddressEn: userInfo?.actualAddressEn,
      eMailOrganization: userInfo?.eMailOrganization,
      phone: userInfo?.phone,
      publicOfficial: userInfo?.publicOfficial,
    };

    // ИП
  } else {
    return {
      indFamily: userInfo?.indFamily,
      indName: userInfo?.indName,
      indSurname: userInfo?.indSurname,
      indFamilyEn: userInfo?.indFamilyEn,
      indNameEn: userInfo?.indNameEn,
      indSurnameEn: userInfo?.indSurnameEn,
      identityDocument: userInfo?.identityDocument,
      identityDocumentEn: userInfo?.identityDocumentEn,
      countryId: userInfo?.countryId,
      inn: userInfo?.inn,
      addressRu: userInfo?.addressRu,
      addressEn: userInfo?.addressEn,
      actualAddressRu: userInfo?.actualAddressRu,
      actualAddressEn: userInfo?.actualAddressEn,
      eMailOrganization: userInfo?.eMailOrganization,
      phone: userInfo?.phone,
      publicOfficial: userInfo?.publicOfficial,

      regDate: userInfo?.regDate,
      regNumber: userInfo?.regNumber,
      registrationAuthorityRu: userInfo?.registrationAuthorityRu,
      registrationAuthorityEn: userInfo?.registrationAuthorityEn,
      registrationLocationRu: userInfo?.registrationLocationRu,
      registrationLocationEn: userInfo?.registrationLocationEn,
    };
  }
};
